import React, {Component} from 'react';
import {Table} from 'semantic-ui-react';
import _ from 'lodash';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';
import './table.scss';

class TotalsSalesList extends Component {
  renderProviders() {
    const {data} = this.props;
    const totalValue = _.sumBy(data, 'amount');

    return data.map((element, index) => {
      const percentage = (element.amount * 100) / totalValue;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{'$'}{getNumericValue(element.amount, 2)}</Table.Cell>
          <Table.Cell textAlign='center'>{getNumericValue(percentage, 0)}%</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Table striped className='totals-table'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>CONCESIONARIO</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>VALOR</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>PORCENTAJE</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
    
        <Table.Body>
          {this.renderProviders()}
        </Table.Body>

      </Table>
    );
  }
}

export default TotalsSalesList;
